<button
  class="ui-icon-button"
  [class.ui-icon-button-ghost]="isGhost()"
  [class.ui-icon-button-soft]="isSoft()"
  [class.ui-icon-button-solid]="isSolid()"
  [attr.aria-label]="ariaLabel()"
  [attr.type]="type()"
  [disabled]="disabled()"
  (click)="handleClick($event)"
>
  <ng-content />
</button>
